import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e327e5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "row"
}
const _hoisted_2 = { class: "col-12 col-lg-4" }
const _hoisted_3 = { class: "col-12 col-lg-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"13px","color":"var(--bs-dark)"} }, " شناسه تراکنش: ", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10px","margin-right":"5px"} }, "در حال ارسال به شبکه ...", -1))
const _hoisted_7 = {
  key: 1,
  class: "buy-invoice__txid"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#0668E1",
  d: "M9.131 17.023H3.145a2.51 2.51 0 0 1-2.507-2.507V6.023a2.51 2.51 0 0 1 2.507-2.507h5.986a2.51 2.51 0 0 1 2.507 2.507v8.493a2.51 2.51 0 0 1-2.507 2.507zM3.145 4.769c-.691 0-1.253.562-1.253 1.254v8.493c0 .691.562 1.253 1.253 1.253h5.986c.691 0 1.253-.562 1.253-1.253V6.023c0-.692-.562-1.254-1.253-1.254H3.145zm11 8.179V3.484A2.51 2.51 0 0 0 11.638.977H4.681a.627.627 0 0 0 0 1.254h6.957c.691 0 1.254.562 1.254 1.253v9.464a.626.626 0 1 0 1.253 0z"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "buy-invoice__txid-value" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!
  const _component_windows_10_loading = _resolveComponent("windows-10-loading")!
  const _component_pre_order_price_box = _resolveComponent("pre-order-price-box")!
  const _component_pre_order_steps = _resolveComponent("pre-order-steps")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_mobile_invoice_success = _resolveComponent("mobile-invoice-success")!
  const _component_desktop_invoice_success = _resolveComponent("desktop-invoice-success")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.copied)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copied = undefined)),
          variant: "primary",
          title: "با موفقیت کپی شد",
          duration: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.status === 'loading' && !_ctx.response)
      ? (_openBlock(), _createBlock(_component_windows_10_loading, {
          key: 1,
          label: "در حال پردازش ..."
        }))
      : _createCommentVNode("", true),
    (_ctx.status === 'success' || _ctx.response)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.breakpoints.isDesktop)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_pre_order_price_box, {
                    toman: _ctx.response.total,
                    tether: _ctx.response.amount
                  }, null, 8, ["toman", "tether"]),
                  _createVNode(_component_pre_order_steps, {
                    list: _ctx.response.state_list
                  }, null, 8, ["list"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.breakpoints.isMobile)
              ? (_openBlock(), _createBlock(_component_mobile_invoice_success, {
                  key: 0,
                  date: _ctx.response.done_date.split(' ')[0],
                  time: _ctx.response.done_date.split(' ')[1],
                  items: [
          {
            title: 'مبلغ پرداختی',
            value: `${Number(_ctx.response.total).toLocaleString()} تومان`,
          },
          {
            title: 'نرخ',
            value: `${Number(_ctx.response.rate).toLocaleString()} تومان`,
          },
          {
            title: 'مقدار',
            value: `${Number(_ctx.response.amount).toLocaleString()} USDT`,
            valueStyle: 'font-family: IRANSansX; direction: ltr;',
          },
          {
            title: 'کارمزد شبکه',
            value: `${Number(_ctx.response.transaction_fee).toLocaleString()} USDT`,
            valueStyle: 'font-family: IRANSansX; direction: ltr;',
          },
          {
            title: 'مقدار دریافتی نهایی',
            value: `${Number(_ctx.response.final).toLocaleString()} USDT`,
            valueStyle: 'font-family: IRANSansX; direction: ltr;',
          },
          {
            title: 'گیرنده',
            value: _ctx.response.address,
            valueStyle: 'font-family: IRANSansX; direction: ltr;',
          },
        ]
                }, {
                  bottom: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass([!_ctx.response.txid && 'd-flex align-items-center'])
                    }, [
                      _hoisted_4,
                      (!_ctx.response.txid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_spinner, {
                              size: "20",
                              style: {"margin-right":"10px"}
                            }),
                            _hoisted_6
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", null, [
                              (_openBlock(), _createElementBlock("svg", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copy(_ctx.response.txid))),
                                style: {"margin-left":"4px"},
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "15",
                                height: "18"
                              }, _hoisted_9))
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("a", {
                                href: _ctx.response.txid_link,
                                target: "_blank"
                              }, _toDisplayString(_ctx.response.txid), 9, _hoisted_11)
                            ])
                          ]))
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["date", "time", "items"]))
              : (_ctx.breakpoints.isDesktop)
                ? (_openBlock(), _createBlock(_component_desktop_invoice_success, {
                    key: 1,
                    items: [
          {
            title: 'مبلغ پرداختی',
            value: `${Number(_ctx.response.total).toLocaleString()} تومان`,
            copy: false,
            valueStyle: 'font-weight: 500',
          },
          {
            title: 'نرخ',
            value: `${Number(_ctx.response.rate).toLocaleString()} تومان`,
            copy: false,
            valueStyle: 'font-weight: 500',
          },
          {
            title: 'مقدار',
            value: `${Number(_ctx.response.amount).toLocaleString()} USDT`,
            copy: false,
            valueStyle:
              'font-family: IRANSansX; direction: ltr;font-weight: 500',
          },
          {
            title: 'کارمزد شبکه',
            value: `${Number(_ctx.response.transaction_fee).toLocaleString()} USDT`,
            copy: false,
            valueStyle:
              'font-family: IRANSansX; direction: ltr;font-weight: 500',
          },
          {
            title: 'مقدار دریافتی نهایی',
            value: `${Number(_ctx.response.final).toLocaleString()} USDT`,
            copy: false,
            valueStyle:
              'font-family: IRANSansX; direction: ltr;font-weight: bold',
          },
          {
            title: 'گیرنده',
            value: _ctx.response.address,
            copy: false,
            valueStyle:
              'font-family: IRANSansX; direction: ltr;font-weight: 500',
          },
          {
            title: 'شناسه تراکنش',
            value: _ctx.response.txid
              ? `${_ctx.response.txid}|${_ctx.response.txid_link}`
              : null,
            copy: true,
            valueStyle:
              'font-family: IRANSansX; direction: ltr;font-weight: 500; font-size: 13px; color: #0668E1;',
          },
        ]
                  }, null, 8, ["items"]))
                : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}